module.exports = new __parcel__URL__("mid-tom_5.c1baf999.mp3").toString();